import * as React from 'react'

import { cn } from './cn'

export interface SkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'text' | 'rectangular' | 'rounded' | 'circular'
  width?: number | string
  height?: number | string
  animation?: 'pulse' | 'wave' | false
}

const Skeleton = React.forwardRef<HTMLSpanElement, SkeletonProps>(
  (
    {
      variant = 'text',
      width,
      height,
      animation = 'pulse',
      className,
      style,
      ...props
    },
    ref,
  ) => (
    <span
      ref={ref}
      className={cn(
        'block bg-black/[0.07] dark:bg-white/[0.08]',
        animation !== false && 'animate-pulse',
        variant === 'text' && 'h-[1.2em] w-full rounded-md',
        variant === 'rectangular' && 'rounded-none',
        variant === 'rounded' && 'rounded-card',
        variant === 'circular' && 'rounded-full',
        className,
      )}
      style={{ width, height, ...style }}
      {...props}
    />
  ),
)
Skeleton.displayName = 'Skeleton'

export default Skeleton
